import type { TenantStatus } from '@inou/shared';
import { isReadOnlyTenantStatus } from '@inou/shared';

import { buttonVariants } from '@/components/ui/button';

/**
 * データの持ち出しと、テナントの状態の告知。
 *
 * 解約済み・削除予定でもエクスポートは通る (GET なので API 側の読み取り許可に
 * 入る)。**押せると分かっていることが要件の半分**なので、状態の告知と同じ節に
 * 置く。工数データは会計証跡でもあるため、契約が終わった後こそ導線が要る。
 *
 * ダウンロードは通常の `<a>`。Cookie が付き、GET なので Origin 検査も関係ない。
 */
const STATUS_NOTES: Record<TenantStatus, string | null> = {
  active: null,
  suspended:
    'このテナントは運営により停止されています。ご不明な点はサポートへお問い合わせください。',
  canceled:
    'ご契約は終了しています。閲覧とデータのエクスポートはできますが、記録と変更はできません。',
  pending_deletion:
    'このテナントは削除予定です。閲覧とデータのエクスポートはできますが、記録と変更はできません。',
};

export function TenantDataSection({
  isAdmin,
  status,
  deletionScheduledAt,
}: {
  isAdmin: boolean;
  status: TenantStatus;
  deletionScheduledAt: number | null;
}) {
  const note = STATUS_NOTES[status];

  return (
    <section className="flex flex-col gap-4 border border-line bg-surface-raised px-6 py-5 lg:col-span-2">
      <h2 className="text-sm font-bold">データのエクスポート</h2>

      {note ? (
        <p
          className={`text-xs leading-relaxed ${isReadOnlyTenantStatus(status) ? 'text-alert' : 'text-ink-muted'}`}
        >
          {note}
          {deletionScheduledAt !== null ? (
            <>
              {' '}
              {'削除予定日は '}
              <span className="font-mono">
                {new Date(deletionScheduledAt * 1000).toLocaleDateString('ja-JP')}
              </span>
              {' です。'}
            </>
          ) : null}
        </p>
      ) : null}

      <p className="text-xs leading-relaxed text-ink-subtle">
        {'メンバー・プロジェクト・アサイン・工数・予算を JSON ファイル 1 本にまとめて' +
          'ダウンロードします。パスワードや認証情報は含まれません。' +
          'ご契約が終了した後も、この画面からいつでも取り出せます。'}
      </p>

      {isAdmin ? (
        <div>
          <a href="/api/export" download className={buttonVariants({ variant: 'primary' })}>
            {'エクスポート (JSON)'}
          </a>
        </div>
      ) : (
        <p className="text-xs text-ink-subtle">{'エクスポートできるのは管理者だけです。'}</p>
      )}
    </section>
  );
}
